import { resolveApiUrl } from "./resolve-api-url.js";
import { browserRuntimeConfig } from "./runtime-config.js";

export const API_URL = resolveApiUrl(
  browserRuntimeConfig.apiUrl,
  typeof window === "undefined" ? undefined : window.location,
);

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_URL}/api${path}`, {
    credentials: "include",
    headers: { "content-type": "application/json", ...init?.headers },
    ...init,
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }

  const body = await response.text();

  return body ? (JSON.parse(body) as T) : (undefined as T);
}

export function json(value: unknown): RequestInit {
  return { method: "POST", body: JSON.stringify(value) };
}
